import {TFunction} from "i18next";
import {formError} from "../../components/forms/formUtils";

export function fieldMin1Error(t: TFunction) {
  return formError(t, 'mustHaveAtLeastOneElement', 'Application.');
}

export function fieldDefinedError(t: TFunction) {
  return formError(t, 'mustBeDefined', 'Application.');
}
